import { matchesAirror, NO_AUTH_HEADER, NOT_AUTHENTICATED, SESSION_EXPIRED } from '@air/errors';
import { convertUnknownToError } from '@air/utils-error';

const NO_CURRENT_USER_ERROR = 'No current user';

export const isUnauthenticatedApiError = (error: unknown): boolean => {
  if (
    matchesAirror(error, NO_AUTH_HEADER) ||
    matchesAirror(error, NOT_AUTHENTICATED) ||
    matchesAirror(error, SESSION_EXPIRED)
  ) {
    return true;
  }

  const knownError = convertUnknownToError(error);

  if (
    knownError.message.includes(NO_AUTH_HEADER.message) ||
    knownError.message.includes(NO_CURRENT_USER_ERROR) ||
    knownError.message.includes(NOT_AUTHENTICATED.message)
  ) {
    return true;
  }

  return false;
};
